"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    localePlugin: ()=>localePlugin
});
const index_js_namespaceObject = require("../../locale/index.js");
function localePlugin(localeConfig) {
    return {
        request: [
            (config)=>{
                var _config_pluginConfig, _config_pluginConfig1;
                if (null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig.localeDisabled) return config;
                var _localeConfig_locale, _ref;
                const locale = null != (_ref = null != (_localeConfig_locale = null == localeConfig ? void 0 : localeConfig.locale) ? _localeConfig_locale : null == (_config_pluginConfig1 = config.pluginConfig) ? void 0 : _config_pluginConfig1.locale) ? _ref : index_js_namespaceObject.defaultCloudLocale;
                var _config_headers;
                config.headers = null != (_config_headers = config.headers) ? _config_headers : {};
                config.headers['Accept-Language'] = locale;
                return config;
            }
        ]
    };
}
exports.localePlugin = __webpack_exports__.localePlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "localePlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
